import { registerPlugin } from "@capacitor/core";

const PenguinPlugin = registerPlugin("PenguinPlugin");

export default PenguinPlugin;
